import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FriendlyCurrencyPipe } from './friendly-currency.pipe';

@NgModule({
  declarations: [FriendlyCurrencyPipe],
  imports: [CommonModule],
  exports: [FriendlyCurrencyPipe],
})
export class FriendlyCurrencyPipeModule {}
